import { NavLink, useNavigate } from "react-router-dom";

import {
  FaUser,
  FaHeart,
  FaBoxOpen,
  FaSignOutAlt,
} from "react-icons/fa";

export default function AccountSidebar() {
  const navigate = useNavigate();

  const user = JSON.parse(
    localStorage.getItem("user") || "{}"
  );

  const initials =
    user?.first_name && user?.last_name
      ? `${user.first_name[0]}${user.last_name[0]}`
      : user?.username?.[0]?.toUpperCase() || "U";

  const logout = () => {
    localStorage.removeItem("user");
    navigate("/");
    window.location.reload();
  };

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 ${
      isActive
        ? "bg-[#0F766E] text-white shadow-sm"
        : "text-[#1F2937] hover:bg-[#E6F3F1] hover:text-[#0F766E]"
    }`;

  return (
    <div className="
      bg-[#FFFDF8]
      rounded-2xl
      shadow-sm
      border
      border-[#E5DDCC]
      overflow-hidden
    ">

      {/* User */}
      <div className="
        p-6
        border-b
        border-[#E5DDCC]
      ">
        <div className="
          w-16
          h-16
          rounded-full
          bg-[#0F766E]
          text-white
          flex
          items-center
          justify-center
          text-xl
          font-bold
          mx-auto
          shadow-sm
        ">
          {initials}
        </div>

        <h2 className="
          mt-4
          text-lg
          font-semibold
          text-center
          text-[#1F2937]
        ">
          {user?.first_name
            ? `${user.first_name} ${user.last_name || ""}`
            : user?.username}
        </h2>

        <p className="
          text-[#8A8172]
          text-sm
          text-center
          break-all
          mt-1
        ">
          {user?.email}
        </p>
      </div>

      {/* Menu */}
      <div className="p-3 space-y-2">

        <NavLink
          to="/profile"
          end
          className={linkClass}
        >
          <FaUser />
          Profile
        </NavLink>

        <NavLink
          to="/orders"
          className={linkClass}
        >
          <FaBoxOpen />
          My Orders
        </NavLink>

        <NavLink
          to="/favourite"
          className={linkClass}
        >
          <FaHeart />
          Wishlist
        </NavLink>

        <button
          onClick={logout}
          className="
            flex
            items-center
            gap-3
            px-4
            py-3
            rounded-xl
            text-[#B42318]
            hover:bg-[#FDECEC]
            transition
            w-full
          "
        >
          <FaSignOutAlt />
          Logout
        </button>

      </div>
    </div>
  );
}